import { render, staticRenderFns } from "./age.input.vue?vue&type=template&id=2e866d9e&"
import script from "./age.input.vue?vue&type=script&lang=ts&"
export * from "./age.input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports